import React, { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchUsersData } from "../../action/usersAction";
import moment from "moment";
import BlankImg from "../../assets/images/blank.jpg";
import { ImageWithFallback } from "../../helper/helper";
import Pagination from "../../component/Pagination";
import EditIcon from "@mui/icons-material/Edit";
import "datatables.net-dt/css/dataTables.dataTables.min.css";
import "datatables.net-responsive-dt/css/responsive.dataTables.css";
import "datatables.net-buttons-dt/css/buttons.dataTables.css";
import "datatables.net";
import "datatables.net-responsive";
import "datatables.net-buttons";
import {
  Box,
  Paper,
  styled,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Button,
  Modal,
  TableSortLabel,
  Tooltip,
  IconButton,
} from "@mui/material";
import DeleteIcon from "../../assets/images2/deleteIcon.svg";
import { defineLocale } from "moment/moment";
import VisibilityIcon from "@mui/icons-material/Visibility";
import CheckBox from "../../component/CheckBox";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import SearchIcon from "@mui/icons-material/Search";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import CardActionArea from "@mui/material/CardActionArea";
import CardActions from "@mui/material/CardActions";
import LisitingSkeletonUsers from "../common/LisitingSkeletonUsers";
import ViewUser from "../../component/Modals/ViewUser";
import AddIcon from "@mui/icons-material/Add";
import VoteImg from "../../assets/images2/votes.svg";
import AssignVotes from "../../component/Modals/AssignVotes";
import DeleteIconMui from "@mui/icons-material/Delete";
import CloseIcon from "@mui/icons-material/Close";

const CustomTableCell = styled(TableCell)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(1),
  borderBottom: "none !important",
  position: "relative",
  "&::before": {
    // backgroundImage: `url(${addCircleIcon})`,
  },
}));

const goalsColumn = [
  { id: "user_select", label: "", minWidth: 105 },
  { id: "firstName", label: "NAME", minWidth: 105 },
  { id: "email", label: "EMAIL", minWidth: 105 },
  { id: "phone_number", label: "PHONE NUMBER", minWidth: 105 },
  { id: "createdAt", label: "JOINED ON", minWidth: 500 },
  { id: "user_actions", label: "ACTIONS", minWidth: 210 },
];

const columnsToSort = ["firstName", "email", "createdAt"];

export default function Users() {
  const leadsData = useSelector((state) => state.users);
  const token = useSelector((state) => state.auth.token);
  const [myLeads, setLeads] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const dispatch = useDispatch();
  const tableRef = useRef(null);
  const [selectall, setSelectAll] = useState(false);
  const multipleSelect = useRef(new Map());
  const [openDelete, setOpenDelete] = useState(false);
  const deleteSelected = useRef(null);
  const [search, setSearch] = useState("");
  const [userView, setUserView] = useState(false);
  const [openMulitDelete, setOpenMulitDelete] = useState(false);
  const [assignVote, setAssignVote] = useState(false);
  const [page, setPage] = useState(1);
  const [uploadingUser, setUploadingUser] = useState(null);
  const fileInputRef = useRef(null);

  const [sortColumn, setSortColumn] = useState(null);
  const [sortOrder, setSortOrder] = useState("ASC");

  useEffect(() => {
    dispatch(fetchUsersData(token, "", 1));
  }, [dispatch, token]);

  useEffect(() => {
    if (leadsData?.data?.success) {
      if (leadsData?.data?.data?.rows?.length > 0) {
        setLeads(leadsData.data?.data.rows);
        setCurrentPage(leadsData?.data?.data?.currentPage);
        setTotalPages(Math.ceil(leadsData?.data?.data?.count / 10));
      } else {
        setLeads("No Users!");
      }
    } else if (!leadsData?.data?.success) {
      setLeads(leadsData?.data?.message);
    }
  }, [leadsData]);

  useEffect(() => {
    dispatch(fetchUsersData(token, search, 1, sortColumn, sortOrder));
  }, [sortColumn, sortOrder]);

  const handleSort = (column) => {
    const isAsc = sortColumn == column && sortOrder == "ASC";
    setSortOrder(isAsc ? "DESC" : "ASC");
    setSortColumn(column);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    dispatch(fetchUsersData(token, search, newPage, sortColumn, sortOrder));
  };

  // function handleSelectChange(e) {}

  function handleDeleteClose() {
    setOpenDelete(false);
  }

  async function handleDelete() {
    try {
      const response = await axios.delete(
        `${process.env.REACT_APP_API_URL}/deleteUser/${deleteSelected.current.id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.data.success) {
        dispatch(
          fetchUsersData(token, search, currentPage, sortColumn, sortOrder)
        );
        toast.success("User deleted successfully");
      }
    } catch (error) {
      toast.error("Please try again..");
    } finally {
      setOpenDelete(false);
    }
  }

  function handleSearchClick() {
    if (search.trim() !== "") {
      dispatch(
        fetchUsersData(token, search, currentPage, sortColumn, sortOrder)
      );
    }
  }
  async function handleProfileUpload(event, user) {
    try {
      const file = event.target.files[0];

      if (!file) return;

      setUploadingUser(user.id);

      const formData = new FormData();

      formData.append("profileImage", file);

      formData.append("user_id", user.id);

      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/editUserDetails`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.data.success) {
        toast.success("Profile image updated successfully");

        refreshHandler();
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Failed to upload image");
    } finally {
      setUploadingUser(null);

      event.target.value = "";
    }
  }
  async function handleMultipleDelete() {
    try {
      const ids = Array.from(multipleSelect.current.entries()).map(
        (ele) => ele[0]
      );
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/deleteMultipleUsers`,
        {
          ids,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.data.success) {
        dispatch(
          fetchUsersData(token, search, currentPage, sortColumn, sortOrder)
        );
        toast.success("Selected Users deleted successfully");
      }
    } catch (error) {
      toast.error("Please try again..");
    } finally {
      multipleSelect.current.clear();
      setOpenMulitDelete(false);
    }
  }

  const refreshHandler = useCallback(() => {
    dispatch(fetchUsersData(token, search, page, sortColumn, sortOrder));
  }, [sortColumn, token, search, sortOrder, page]);

  return (
    <React.Fragment>
      <Box className="page_title">
        <Typography variant="h1" component="h1">
          Users
        </Typography>
      </Box>
      <Box className="page_inner">
        <Box className="search_box_wrapper">
          <Box className="search_box">
            <Box className="input-wrapper">
              <Box sx={{ flexGrow: "1", position: "relative" }}>
                <SearchIcon
                  className="searchIcon"
                  onClick={handleSearchClick}
                />
                <input
                  placeholder="Search by First Name , Last Name and Email"
                  type="text"
                  value={search}
                  onChange={(e) => {
                    if (e.target.value.trim() == "") {
                      dispatch(fetchUsersData(token, "", 1));
                    } else {
                      dispatch(
                        fetchUsersData(token, e.target.value, currentPage)
                      );
                    }
                    setSearch(e.target.value);
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      dispatch(fetchUsersData(token, search, currentPage));
                    }
                  }}
                  style={{ width: "100%" }}
                />

                {search && (
                  <IconButton
                    sx={{ position: "absolute", right: "0", top: "5px" }}
                    onClick={() => {
                      setSearch("");
                      dispatch(fetchUsersData(token, "", 1));
                    }}
                  >
                    <CloseIcon />
                  </IconButton>
                )}
              </Box>

              <Button
                className="delete-search-btn"
                onClick={() => {
                  if (
                    multipleSelect.current &&
                    multipleSelect.current.size > 0
                  ) {
                    setOpenMulitDelete(true);
                  } else {
                    toast.error("Please select atleast one user");
                  }
                }}
              >
                <Tooltip title="Delete Selected Users" placement="top">
                  <DeleteOutlineIcon className="delete-icon" />
                </Tooltip>
              </Button>
            </Box>
          </Box>
        </Box>
        <Box className="page_table">
          <TableContainer component={Paper} className=" user_table">
            <Table
              aria-label="leads table"
              id="leadsTable"
              className="display responsive nowrap"
              style={{ width: "100%", minWidth: "900px" }}
            >
              <TableHead className="table_Head">
                <TableRow key="tb_head_users">
                  {goalsColumn.map((column) =>
                    column.id != "user_select" ? (
                      <TableCell key={column.id}>
                        {columnsToSort.includes(column.id) ? (
                          <TableSortLabel
                            active={sortColumn === column.id}
                            onClick={() => handleSort(column.id)}
                            direction={sortOrder.toLowerCase()}
                          >
                            {column.label}
                          </TableSortLabel>
                        ) : (
                          column.label
                        )}
                      </TableCell>
                    ) : (
                      <TableCell key={column.id}>
                        <Box className="checkbox-td">
                          <input
                            type="checkbox"
                            className="siteCheckBox"
                            checked={selectall}
                            onChange={(e) => {
                              if (!e.target.checked) {
                                multipleSelect.current.clear();
                              }
                              setSelectAll(e.target.checked);
                            }}
                          />
                        </Box>
                      </TableCell>
                    )
                  )}
                </TableRow>
              </TableHead>
              <TableBody>
                {Array.isArray(myLeads) && myLeads.length > 0 ? (
                  // && false
                  myLeads.map((value, index) => (
                    <TableRow key={index}>
                      <TableCell>
                        <Box className="checkbox-td">
                          <CheckBox
                            multipleSelect={multipleSelect}
                            selectall={selectall}
                            data={value}
                            key={value.id}
                          />
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Box
                          className="username"
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: "14px",
                          }}
                        >
                          <Box
                            className="u_image"
                            sx={{
                              position: "relative",

                              width: 52,
                              height: 52,

                              minWidth: 52,

                              padding: "2px",

                              borderRadius: "50%",

                              overflow: "visible",

                              border: "2px solid #f1f5f9",

                              background: "#f8fafc",

                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",

                              "& img": {
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                                borderRadius: "50%",
                              },
                            }}
                          >
                            <ImageWithFallback
                              src={value.profile_img}
                              alt=""
                              fallbackSrc={BlankImg}
                            />

                            {/* EDIT BUTTON */}

                            <Tooltip
                              title="Update profile image"
                              placement="top"
                            >
                              <IconButton
                                size="small"
                                component="label"
                                sx={{
                                  position: "absolute",
                                  right: "0px",
                                  bottom: "5px",

                                  width: 20,
                                  height: 20,

                                  background: "#ff3152",

                                  color: "#fff",

                                  border: "2px solid #fff",

                                  "&:hover": {
                                    background: "#e11d48",
                                  },
                                }}
                              >
                                <EditIcon
                                  sx={{
                                    fontSize: "13px",
                                  }}
                                />

                                <input
                                  hidden
                                  type="file"
                                  accept="image/*"
                                  onChange={(e) =>
                                    handleProfileUpload(e, value)
                                  }
                                />
                              </IconButton>
                            </Tooltip>

                            {/* LOADING */}

                            {uploadingUser === value.id && (
                              <Box
                                sx={{
                                  position: "absolute",
                                  inset: 0,
                                  background: "rgba(255,255,255,0.7)",

                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",

                                  borderRadius: "50%",
                                }}
                              >
                                <Typography
                                  sx={{
                                    fontSize: "10px",
                                    fontWeight: 600,
                                  }}
                                >
                                  Uploading...
                                </Typography>
                              </Box>
                            )}
                          </Box>
                          <Typography
                            variant="h4"
                            component="h4"
                            className="u_name"
                          >
                            {value.firstName + " " + value.lastName}
                          </Typography>
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Box className="td-wrapper td-title">
                          <Typography
                            variant="h4"
                            component="h4"
                            className="td-text"
                          >
                            {value.email}
                          </Typography>
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Box className="td-wrapper td-title">
                          <Typography
                            variant="h4"
                            component="h4"
                            className="td-text"
                          >
                            {value?.phone_number
                              ? `(${value.phone_number.slice(
                                  -value.phone_number.length,
                                  -10
                                )}) ${value.phone_number.slice(-10)}`
                              : ""}
                            {/* {value.phone_number || ""} */}
                          </Typography>
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Box className="td-wrapper">
                          <Typography
                            variant="p"
                            component="p"
                            className="td-text"
                          >
                            {moment(value.createdAt).format("MMM D,YYYY")}
                          </Typography>
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Box className="table-actions">
                          <Box className="action-wrapper">
                            <Tooltip title="Delete user" placement="top">
                              <Button
                                variant="text"
                                onClick={() => {
                                  deleteSelected.current = value;
                                  setOpenDelete(true);
                                }}
                                className="visible_user"
                              >
                                {/* <img src={DeleteIcon} alt="" /> */}
                                <DeleteIconMui className="visible_icon" />
                              </Button>
                            </Tooltip>
                            <Tooltip title="View users" placement="top">
                              <Button
                                variant="outlined"
                                className="visible_user"
                                onClick={() => {
                                  deleteSelected.current = value;
                                  setUserView(true);
                                }}
                              >
                                <VisibilityIcon className="visible_icon" />
                              </Button>
                            </Tooltip>

                            <Tooltip title="Assign votes" placement="top">
                              <Button
                                variant="outlined"
                                className="visible_user"
                                onClick={() => {
                                  deleteSelected.current = value;
                                  setAssignVote(true);
                                }}
                              >
                                <img
                                  src={VoteImg}
                                  alt="vote"
                                  className="img_fluid"
                                />
                                <AddIcon className="visible_icon" />
                              </Button>
                            </Tooltip>
                          </Box>
                        </Box>
                      </TableCell>
                    </TableRow>
                  ))
                ) : myLeads !== "No Users!" ? (
                  Array.from({ length: 10 }).map((e, i) => (
                    <LisitingSkeletonUsers />
                  ))
                ) : (
                  <TableRow component={`tr`}>
                    <TableCell colSpan={5} style={{ textAlign: "center" }}>
                      {myLeads}
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          {totalPages > 1 && (
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              handleChangePage={handleChangePage}
            />
          )}
        </Box>
      </Box>

      {/* delete user modal  */}
      <Modal
        open={openDelete}
        onClose={handleDeleteClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="deleteModal">
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Are You sure . You want to delete this user.
          </Typography>
          <Box className="buttons-div">
            <Button variant="outlined" onClick={() => setOpenDelete(false)}>
              cancel
            </Button>
            <Button variant="outlined" onClick={handleDelete}>
              Delete
            </Button>
          </Box>
        </Box>
      </Modal>

      {/* view user modal  */}
      <ViewUser
        setUserView={setUserView}
        userView={userView}
        deleteSelected={deleteSelected}
      />

      {/* delete multiple video delete modal  */}
      <Modal
        open={openMulitDelete}
        onClose={() => setOpenMulitDelete(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="deleteModal">
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Are You sure . You want to delete the selected users.
          </Typography>
          <Box className="buttons-div">
            <Button
              variant="outlined"
              onClick={() => setOpenMulitDelete(false)}
            >
              cancel
            </Button>
            <Button variant="outlined" onClick={handleMultipleDelete}>
              Delete
            </Button>
          </Box>
        </Box>
      </Modal>

      {/* assign votes to user model */}
      <AssignVotes
        setOpen={setAssignVote}
        open={assignVote}
        selectedUser={deleteSelected}
        refreshUser={refreshHandler}
      />
    </React.Fragment>
  );
}
